import React from 'react';
import RedpacketItem from './RedpacketItem';

const SingelRedpacketList = (props: any) => {
  const { unSendList, chatId, activityCode, getRedpacketList, wsid, shareInfo, groupFlag, sendTotal, activityInfo, currentCgmStoreCode} = props;
  return (<div className="redpacket-list-wrapper">
     <div className="send-title not-send">未使用 {unSendList && unSendList.length || 0} 个</div>
    {
      unSendList && unSendList.length > 0 ? 
      <div className="redpacket-list">
      {
        unSendList && unSendList.map((r: any) =>
          <RedpacketItem
            redpacket={r}
            key={r.redpacketCode}
            chatId={chatId}
            activityCode={activityCode}
            getRedpacketList={getRedpacketList}
            wsid={wsid}
            shareInfo={shareInfo}
            groupFlag={groupFlag}
            activityInfo={activityInfo}
            currentCgmStoreCode={currentCgmStoreCode}
          ></RedpacketItem>
        )
      }
      </div>
     : <div className="no-sendlist">无可用</div>
    }
    <div className="send-title">已发送 {sendTotal || 0} 个</div>
    <div className="tip">请勿多次向同一顾客发送</div>
  </div>)
}
export default SingelRedpacketList